export * from './app-sidebar-minimizer.component';



// WEBPACK FOOTER //
// D:/desv/producao/hc/angular/adminHC/src/app/components/app-sidebar-minimizer/index.ts